import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import TableCasino from '../../../../../@casino/ui/table';
import { useDispatch, useSelector } from 'react-redux';
import { setGetStatLottery } from '../../store/thunk/setGetStatLottery';
import { setPostIssueLottery } from '../../store/thunk/setPostIssueLottery';
import { setGetByIdLottery } from '../../store/thunk/setGetByIdLottery';
import Dialog from '@material-ui/core/Dialog';
import { setGetWinnersLottery } from '../../store/thunk/setGetWinnersLottery';

const LotteryStat = () => {
    const router = useRouter();
    const {id} = router.match.params;
    const dispatch = useDispatch();
    
    const [openModal, setOpenModal] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetStatLottery({
            id,
            page: 1,
            rowsPerPage: 10,
        }));
        dispatch(setGetByIdLottery({id}));
        dispatch(setGetWinnersLottery({
            id,
            page: 1,
            rowsPerPage: 10
        }))
    }, [id]);

    const stat = useSelector(state => state.lottery.stat);
    const view = useSelector(state => state.lottery.view);
    const win = useSelector(state => state.lottery.winners);

    const getRows = (val) => {
        return  val.map((item) => {
            return {
                id: item.id_profile,
                login: item.login,
                ticket: item.ticket,
                gold_ticket: item.gold_ticket
            }
        })
    } 

    const columnsWinners = [
        { id: 'id', label: 'ID игрока'},
        { id: 'login', label: 'Логин'},
        { id: 'ticket', label: 'Кол-во билетов'},
        { id: 'gold_ticket', label: 'Кол-во золотых билетов'},
        { id: 'place', label: 'Место'}
    ]

    const getRowsWinners = (val) => {
        return  val.map((item) => {
            return {
                id: item.id_profile,
                login: item.login,
                ticket: item.ticket,
                gold_ticket: item.gold_ticket,
                place: item.place
            }
        })
    }

    const rows = getRows(stat.data)
    const rowsWinners = getRowsWinners(win.data);
    const columns = [
        { id: 'id', label: 'ID игрока'},
        { id: 'login', label: 'Логин'},
        { id: 'ticket', label: 'Кол-во билетов'},
        { id: 'gold_ticket', label: 'Кол-во золотых билетов'},
    ]

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Статистика для лотереии" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span 
                    style={{
                        padding: '10px',
                        background: 'rgb(255, 195, 36)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        color: 'rgb(20, 27, 51)',
                    }}
                    onClick={() => router.history.push(`/lottery/edit/${id}`)}
                >Назад</span>
                <span 
                    style={{
                        padding: '10px',
                        background: view.status ? 'rgb(255, 195, 36)' : 'grey',
                        borderRadius: '4px',
                        cursor: view.status ? 'pointer' : 'default',
                        color: 'rgb(20, 27, 51)',
                        userSelect: 'none',
                    }}
                    onClick={() => {
                        if (view.status) {
                            dispatch(setPostIssueLottery({id}, setOpenModal))
                        }
                    }}
                >{view.status ? 'Выдать призы' : 'Призы выданы'}</span>
            </div>
            {
                view.status &&
                <div style={{
                    padding: 20, 
                    background: '#1b2039', 
                    borderRadius: 8, 
                }}>
                    <TableCasino 
                        width={900}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        pagination
                        allPage={stat.page}
                        changePage={(v) => dispatch(setGetStatLottery({
                            page: +v.page+1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetStatLottery({
                            page: +v.page + 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    />
                </div>
            }
            {
                !view.status &&
                <div style={{
                    padding: 20, 
                    background: '#1b2039', 
                    borderRadius: 8, 
                }}>
                    <h3 style={{margin: 0, padding: 0, color: '#fff', marginBottom: 12}}>Список победителей</h3>
                    <TableCasino 
                        width={900}
                        perPage={10}
                        columns={columnsWinners}
                        rows={rowsWinners}
                        pagination
                        allPage={stat.page}
                        changePage={(v) => dispatch(setGetWinnersLottery({
                            page: +v.page+1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetWinnersLottery({
                            page: +v.page + 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    />
                </div>
            }
            
            <Dialog onClose={() => {
                setOpenModal(false);
                dispatch(setGetByIdLottery({id}))
            }} open={openModal}>
                <div style={{background: 'rgb(27, 32, 57)', padding: 20}}>
                    <h3 style={{margin: 0, padding: 0, color: '#fff'}}>Призы успешно выданы</h3>
                    <div style={{marginTop: 22}}>
                        <span 
                            style={{
                                background: 'rgb(255, 195, 36)',
                                padding: '10px 50px',
                                borderRadius: 4,
                                display: 'flex',
                                justifyContent: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                setOpenModal(false);
                                dispatch(setGetByIdLottery({id}))
                                dispatch(setGetWinnersLottery({
                                    id,
                                    page: 1,
                                    rowsPerPage: 10
                                }))
                            }}
                        >
                            ОК
                        </span>
                    </div> 

                    
                </div>
            </Dialog>
        </div>
    )
}

export default LotteryStat;